import Vue from 'vue';

const websocketEventBus = new Vue();

websocketEventBus.updateNotifications = (data) => {
    websocketEventBus.$emit('update-notifications', data);
};
websocketEventBus.subscribeToUpdateNotifications = (handler) => {
    websocketEventBus.$on('update-notifications', handler);
};
websocketEventBus.unsubscribeFromUpdateNotifications = (handler) => {
    websocketEventBus.$off('update-notifications', handler);
};


websocketEventBus.saveEnroll = (data) => {
    websocketEventBus.$emit('save-enroll', data);
};
websocketEventBus.subscribeToSaveEnroll = (handler) => {
    websocketEventBus.$on('save-enroll', handler);
};
websocketEventBus.unsubscribeFromSaveEnroll = (handler) => {
    websocketEventBus.$off('save-enroll', handler);
};


websocketEventBus.deleteEnroll = (data) => {
    websocketEventBus.$emit('delete-enroll', data);
};
websocketEventBus.subscribeToDeleteEnroll = (handler) => {
    websocketEventBus.$on('delete-enroll', handler);
};
websocketEventBus.unsubscribeFromDeleteEnroll = (handler) => {
    websocketEventBus.$off('delete-enroll', handler);
};


websocketEventBus.updateBalance = (data) => {
    websocketEventBus.$emit('update-balance', data);
};
websocketEventBus.subscribeToUpdateBalance = (handler) => {
    websocketEventBus.$on('update-balance', handler);
};
websocketEventBus.unsubscribeFromUpdateBalance = (handler) => {
    websocketEventBus.$off('update-balance', handler);
};


websocketEventBus.newSupport = (data) => {
    websocketEventBus.$emit('new-support', data);
};
websocketEventBus.subscribeToNewSupport = (handler) => {
    websocketEventBus.$on('new-support', handler);
};
websocketEventBus.unsubscribeFromNewSupport = (handler) => {
    websocketEventBus.$off('new-support', handler);
};

export default websocketEventBus;
